import { render, staticRenderFns } from "./camerdetail.vue?vue&type=template&id=e2880450&scoped=true&"
import script from "./camerdetail.vue?vue&type=script&lang=js&"
export * from "./camerdetail.vue?vue&type=script&lang=js&"
import style0 from "./camerdetail.vue?vue&type=style&index=0&id=e2880450&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2880450",
  null
  
)

export default component.exports